module.exports = __webpack_public_path__ + "img/hortencias.d57d72a7.jpg";